import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {MaterialModule} from './material.module';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { loadGoogleMapsScript } from './utils/google-maps-loader';

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone : true,
  imports : [RouterOutlet, MaterialModule, TranslateModule],
  providers : [HttpClient]
})
export class AppComponent {
  ngOnInit() {
    loadGoogleMapsScript(environment.googleMapsApiKey).catch(() => {
      // Ignore load errors to avoid breaking app boot when Maps is optional.
    });
  }

}
